import { render, staticRenderFns } from "./KeysSidebar.vue?vue&type=template&id=37353d2f"
import script from "./KeysSidebar.vue?vue&type=script&lang=js"
export * from "./KeysSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports